module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Socks-becd201818682e2ddbce45231be0e14a.svg";